const profileHR = {
    "edit": {
        "title": "Uredite svoj profil",
        "form": {
            "label": {
                "profileImage": "Profilna slika",
                "streetAndNumber": "Moja ulica i kućni broj",
                "postalCode": "Poštanski broj",
                "city": "Grad",
                "country": "Država",
                "vatNumber": "PDV broj",
                "nationalTaxNumber": "Nacionalni porezni broj",
                "businessRegistrationNumber": "Broj registracije poslovanja",
                "vatStatus": "Status PDV-a",
                "businessType": "Vrsta poslovanja",
                "vatExemptDocument": "Dokument o oslobođenju PDV-a",
                "businessCertificate": "Poslovni certifikat",
                "preferredPaymentMethod": "Preferirani način plaćanja",
                "paypalEmail": "Paypal email",
                "accountHolderName": "Ime vlasnika bankovnog računa",
                "bankName": "Ime banke",
                "bankAddress": "Adresa banke",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Bankovni račun"
                }
            },
            "help_text": {
                "profileImage": "Prenesite JPG formate, rezolucija samo 300x300 px, maksimalna veličina 300 KB.",
                "iban": "Sjetite se prefiksa vaše zemlje, na primjer DE, FR, ES"
            },
            "button": {
                "submit": "Pošalji"
            }
        },
        "message": {
            "success": "Vaš profil je ažuriran!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!"
        },
        "modal": {
            "header": "Jeste li sigurni da želite promijeniti svoj profil?",
            "body": "Ovim jamčite da su svi dani podaci istiniti. Sami ste i pravno odgovorni za dane podatke i za istinitost tih informacija.",
            "button": {
                "cancel": "Otkaži",
                "confirm": "Potvrdi"
            }
        }
    },
    "set_new_password": {
        "title": "Postavite novu lozinku",
        "form": {
            "label": {
                "currentPassword": "Trenutna lozinka",
                "newPassword": "Nova lozinka",
                "repeatNewPassword": "Ponovite novu lozinku"
            },
            "button": {
                "submit": "Pošalji"
            },
            "validation": {
                "oldPasswordRequired": "Potrebna je vaša stara lozinka",
                "newPasswordMin": "Vaša lozinka treba imati najmanje 10 znakova",
                "newPasswordRequired": "Potrebna je nova lozinka",
                "passwordsMustMatch": "Nova lozinka mora se podudarati"
            }
        },
        "message": {
            "success": "Vaša lozinka je promijenjena!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!"
        },
        "modal": {
            "header": "Jeste li sigurni da želite promijeniti svoju lozinku?",
            "body": "Molimo potvrdite"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "Email adresa",
            "paypalEmailAddress": "Paypal email adresa",
            "phone": "Telefon",
            "streetAndHouseNumber": "Ulica i kućni broj",
            "postalCode": "Poštanski broj",
            "city": "Grad",
            "country": "Država",
            "paymentMethod": "Način plaćanja",
            "accountNumberHolder": "Vlasnik broja računa",
            "bankName": "Ime banke",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Adresa banke",
            "paypal": "Paypal",
            "bankAccount": "Bankovni račun"
        }
    },
    "payment_method": {
        "title": "Način plaćanja",
        "label": {
            "card_number": "Broj kartice",
            "card_expiry": "Istječe",
            "default_method": "Zadano",
            "manage_method": "Upravljaj",
            "add_method": "Dodaj"
        }
    },
    "withholding_tax": {
        "title": "Porez po odbitku",
        "form": {
            "label": {
                "taxPercentage": "Postotak poreza",
                "whtStatus": "Status poreza po odbitku",
                "whtLicense": "Licenca za porez po odbitku"
            },
            "help_text": {
                "uploadDocument": "Molimo prenesite svoj dokument o porezu po odbitku."
            },
            "button": {
                "submit": "Pošalji",
                "removeFile": "Ukloniti?"
            },
            "message": {
                "whtStatusText": "Prema članku 31. Zakona o porezu na dobit Republike Hrvatske, porez po odbitku od 15-25% primjenjuje se na nerezidente. Međutim, ako živite u zemlji koja ima Ugovor o izbjegavanju dvostrukog oporezivanja s Hrvatskom, možete imati pravo na smanjenu poreznu stopu. Možete provjeriti je li vaša zemlja navedena na <1><strong>ovoj poveznici</strong></1>.",
                "whtApplyRateText": "Da biste se prijavili za smanjenu stopu, kliknite na <1><strong>ovaj dokument</strong></1>. Preuzmite, ispunite i pošaljite obrazac kako biste iskoristili stopu navedenu u ugovoru ako ispunjavate uvjete."
            }
        },
        "message": {
            "success": "Licenca za porez po odbitku uspješno poslana. Naš tim će je obraditi.",
            "error": "Došlo je do pogreške prilikom ažuriranja. Molimo pokušajte ponovo."
        }
    }
};

export default profileHR;